function getKitten(props) {
	const shouldGetKitten = Math.random() < 0.3;
	let thisKitten;

	if (!shouldGetKitten) {
		return null;
	}

	if (props.toy === 'toy-Yarn') {
		thisKitten = 'Frisky';
	} else if (props.toy === 'toy-Fishbowl' && props.glasses === 'glasses-Scuba') {
		thisKitten = 'Scuba';
	} else if (props.toy === 'toy-MagicWand' && props.hat === 'hat-Unicorn') {
		thisKitten = 'Unicorn';
	} else if (props.toy === 'toy-Campfire' && props.hat === 'hat-Beanie') {
		thisKitten = 'Camper';
	} else if (props.toy === 'toy-Rocketship') {
		thisKitten = 'Rocketship';
	} else if (props.toy === 'toy-FoamFinger' && props.hat === 'hat-Baseball') {
		thisKitten = 'Fan';
	} else if (props.toy === 'toy-BonsaiTree' && props.glasses === 'glasses-OldMan') {
		thisKitten = 'Bonsai';
	} else if (props.toy === 'toy-Synth' && props.glasses === 'glasses-Sunglasses') {
		thisKitten = 'Midi';
	} else if (props.toy === 'toy-SoccerBall' && props.hat === 'hat-Sweatband') {
		thisKitten = 'Athlete';
	} else if (props.toy === 'toy-Coffee' && props.glasses === 'glasses-Raybans') {
		thisKitten = 'Coffee';
	} else if (props.toy === 'toy-Dough' && props.hat === 'hat-Chef') {
		thisKitten = 'Chef';
	} else if (props.toy === 'toy-Cake' && props.hat === 'hat-PartyHat') {
		thisKitten = 'Birthday';
	}

	return thisKitten;
}

export default getKitten;



// WEBPACK FOOTER //
// ./src/utils/getKitten.js